<template lang="pug">
modal#edit-visibility-modal(
  :no-footer='true'
  :title='$t("modal.envelope.editVisibility.title")'
  ref='modal'
  size='sm'
)
  .form-group
    label.text-start.ps-1.mb-2(for='visibility') {{ $t('modal.envelope.editVisibility.selectLabel') }}
    select#visibility.form-control(v-model='selectedVisibility')
      option(
        :key='opt.value'
        :value='opt.value'
        v-for='opt in visibilityOptions'
      ) {{ opt.label }}
  .text-end.mt-4
    button.btn.btn-secondary(@click='close' type='button') {{ $t('button.cancel') }}
    button.btn.btn-primary.ms-2(@click='changeVisibility' type='button') {{ $t('modal.envelope.editVisibility.change') }}
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'EditVisibilityModal',
  props: {
    visibilityOptions: {
      type: Array,
      required: true,
    },
    visibilitySelected: {
      type: String,
      default: null,
    },
  },
  components: {
    Modal,
  },
  data() {
    return {
      selectedVisibility: this.visibilitySelected,
    };
  },
  watch: {
    visibilitySelected(val) {
      this.selectedVisibility = val;
    },
  },
  methods: {
    close() {
      if (this.$refs.modal) {
        this.$refs.modal.close();
      }
    },
    changeVisibility() {
      let visibility = this.selectedVisibility;
      let team = null;
      if (visibility && visibility.startsWith('team:')) {
        team = visibility.replace('team:', '');
        visibility = 'team';
      }
      const payload = { visibility };
      if (team) {
        payload.team = team;
      }
      this.$emit('change', payload);
    },
  },
};
</script>
